import { forwardRef } from 'react';
import { Box } from '@mui/material';
import { AppPaper, FlexCenVerSpaceBetween, FlexCol } from '@/UI/styles';
import { ShareWorkflowButtonWithModal } from '../ShareWorkflowButtonWithModal';
import { BatchStatusButton } from '../../RunFlow/TaskManager/BatchStatusButton';
import { CREDITS_INFO_WIDTH } from '../../consts/ui';
import { WorkflowCreditsDisplay } from '../WorkflowRightToolbar/WorkflowCreditsDisplay';

interface CreditsInfoProps {
  isPaperBg?: boolean;
}

const CreditsInfoComponent = forwardRef<HTMLDivElement, CreditsInfoProps>(({ isPaperBg = true }, ref) => {
  const Container = isPaperBg ? AppPaper : FlexCol;

  return (
    <Container
      ref={ref}
      sx={{
        ...(isPaperBg
          ? { p: 1, display: 'flex', flexDirection: 'column', width: CREDITS_INFO_WIDTH }
          : { width: '100%' }),
        gap: 1,
      }}
    >
      <FlexCenVerSpaceBetween sx={{ gap: 1 }}>
        <WorkflowCreditsDisplay showCreditsLabel />
        <ShareWorkflowButtonWithModal />
      </FlexCenVerSpaceBetween>
      <Box>
        <BatchStatusButton />
      </Box>
    </Container>
  );
});

CreditsInfoComponent.displayName = 'CreditsInfo';

export const CreditsInfo = CreditsInfoComponent;
